/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const CompareBar = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$body: $('body'),
	$domCompareBar: '.js-products-compare__bar',
	$domCompareBarCloseIcon: '.js-products-compare__bar-icon--close',
	$domCompareBarMinimizeIcon: '.js-products-compare__bar-icon--minimize',
	$domProductCompareIcon: '.js-product-box__icon-compare',
	// classHideCompareBar: 'compare-bar--closed',
	classMinimizeCompareBar: 'compare-bar--minimized',
	classVisible: 'is-visible',

	/** @description Initialize */
	init: function() {
		this.checkCompareBarState();
		this.showCompareBar();
		this.compareBarMinimize();
		this.compareBarClose();
		// if ($('.product-box').length > 0) {
		//     $('.js-products-compare__bar').css('opacity', '1');
		// }
	},

	checkCompareBarState: function() {
		if (localStorage.getItem('compareBarClosed') === 'true') {
			$(CompareBar.$domCompareBar).removeClass(CompareBar.classVisible);
		}
	},

	showCompareBar: function() {
		$(document).on('click', CompareBar.$domProductCompareIcon, function() {
			$(CompareBar.$domCompareBar).addClass(CompareBar.classVisible);
			localStorage.setItem('compareBarClosed', 'false');
		});
	},

	compareBarMinimize: function() {
		$(document).on('click', CompareBar.$domCompareBarMinimizeIcon, function() {
			$(CompareBar.$domCompareBar).toggleClass(CompareBar.classMinimizeCompareBar);
		});
	},

	compareBarClose: function() {
		$(document).on('click', CompareBar.$domCompareBarCloseIcon, function() {
			$(CompareBar.$domCompareBar).removeClass(CompareBar.classVisible);
			$(CompareBar.$domCompareBar).removeClass(CompareBar.classMinimizeCompareBar);
			localStorage.setItem('compareBarClosed', 'true');
		});
	},
};

export default CompareBar;
